import { render, staticRenderFns } from "./PreAndPostStockField.vue?vue&type=template&id=a1bd544e&scoped=true"
import script from "./PreAndPostStockField.vue?vue&type=script&lang=js"
export * from "./PreAndPostStockField.vue?vue&type=script&lang=js"
import style0 from "./PreAndPostStockField.vue?vue&type=style&index=0&id=a1bd544e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bd544e",
  null
  
)

export default component.exports